import BaseIntegration from '@/common/mixins/integrations/baseIntegration';

const mtnRsaIntegrationMixin = {
  extends: BaseIntegration,
  methods: {
    getAlternateRequestPinActionImpl() {
      return (operator) => {
        const userOperator = operator || this.user.operator || sessionStorage.getItem('operator');
        window.location.href = `${window.location.origin}/publicapi/heCheckRedirection?lang=${this.getLocale}&refUrl=${this.getRefUrl || ''}&operator_name=${userOperator || ''}&clickid=${this.getClickId || ''}&publisherId=${this.getPublisherId || ''}&campaignId=${this.getCampaignId || ''}`;
      };
    },

    // getPreRegistrationRedirectionActionImpl() {
    //   return () => {
    //     window.location.href = `${window.location.origin}/publicapi/heCheckRedirection?lang=${this.getLocale}&refUrl=${this.getRefUrl || ''}&clickid=${this.getClickId || ''}&publisherId=${this.getPublisherId || ''}&campaignId=${this.getCampaignId || ''}`;
    //   };
    // },

    // ----------- request/verify methods -------------------------------


    // ----------- reSub/unSub methods ----------------------------------
    alternateReSubActionImpl() {
      return () => {
        const userOperator = sessionStorage.getItem('operator');
        window.location.href = `${window.location.origin}/publicapi/heCheckRedirection?lang=${this.getLocale}&refUrl=${this.getRefUrl || ''}&clickid=${this.getClickId || ''}&publisherId=${this.getPublisherId || ''}&campaignId=${this.getCampaignId || ''}&msisdn=${this.$route.query.msisdn}&operator_name=${userOperator || ''}`;
      };
    },

    // ------------- forgotPin methods --------------------------------------
  },
};

export default mtnRsaIntegrationMixin;



// WEBPACK FOOTER //
// ./src/common/mixins/integrations/mtnrsaIntegration.js